// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import * as React from 'react';
import { VisibleAtContainer } from '../../components/common/containers/VisibleAtContainer';
import { Typography } from '../../lib/base';
import { Link } from '../../lib/link';

interface Props {
  readonly path: string;
  readonly title: string;
  readonly shortTitle: string;
  readonly breakpoint: string;
  readonly onMouseOver?: () => void;
}

export default function ResponsiveLink({ path, title, shortTitle, breakpoint, onMouseOver }: Props) {
  return (
    <Link
      onMouseOver={onMouseOver}
      path={path}
      title={
        <VisibleAtContainer
          up={<Typography variant="body1">{title}</Typography>}
          down={<Typography variant="body1">{shortTitle}</Typography>}
        />
      }
    />
  );
}
